import cx from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import * as style from './button.module.scss';

const Button = forwardRef(
  (
    {
      children,
      className,
      href,
      iconAlt = '',
      iconSrc,
      size = 'medium',
      theme,
      ...props
    },
    ref
  ) => {
    const [As, asProps] = href ? ['a', { href }] : ['button', {}];

    return (
      <As
        {...props}
        {...asProps}
        className={cx(className, style.button, style[size], style[theme])}
        ref={ref}
      >
        {iconSrc && <img className={style.icon} src={iconSrc} alt={iconAlt} />}
        {children}
      </As>
    );
  }
);

Button.displayName = 'Button';

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  iconAlt: PropTypes.string,
  iconSrc: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
  theme: PropTypes.oneOf(['blue', 'light', 'midnight', 'outline']).isRequired,
};

export default Button;
